import { fetcher } from '@commenda/utils';

export async function deleteSubscription({
  companyId,
  subscriptionId,
}: {
  companyId: number;
  subscriptionId: string;
}) {
  const response = await fetcher(
    `billing-new/subscription?companyId=${companyId}&subscriptionId=${subscriptionId}`,
    { method: 'DELETE' }
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(
      errorData.message || `HTTP ${response.status}: ${response.statusText}`
    );
  }

  return response.json().catch(() => ({}));
}
